<!-- <app-header></app-header>
<div class="container mt-5">
    <div class="row justify-content-center">
        <div class="col-md-6">
            <div class="card mb-3">
                <div class="card-header font-weight-bold common">
                    Your Primary Details
                </div>
                <div class="card-body">
                    <form [formGroup]="registrationForm">
                        <label for="Email Id" class="form-label font-weight-bold">Email Id</label>
                        <input placeholder="" class="form-control" formControlName="email" readonly>
                        <label for="name" class="form-label font-weight-bold">Name*</label>
                        <input placeholder="" class="form-control" formControlName="name">
                        <div *ngIf="registrationForm.get('name')?.touched && registrationForm.get('name')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            <label>{{ errorMessages.emptyNameError }}</label>
                        </div>
                        <label for="Age" class="form-label font-weight-bold">Age*</label>
                        <input placeholder="" class="form-control" formControlName="age" type="number">
                        <div *ngIf="registrationForm.get('age')?.touched && registrationForm.get('age')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            <label>{{ errorMessages.emptyAgeError }}</label>
                        </div>
                        <label for="Gender" class="form-label font-weight-bold">Gender*</label>
                        <select class="form-select mb-3" formControlName="gender"
                            (change)="selectOption($event, 'gender')">
                            <option value="" selected disabled>Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Others">Others</option>
                        </select>
                        <div *ngIf="registrationForm.get('gender')?.value === '' && registrationForm.get('mobileNumberPrimary')?.value !== ''"
                            class="text-danger font-weight-bold">
                            {{ errorMessages.emptyGenderError }}
                        </div>
                        <label for="Primary Mobile Number" class="form-label font-weight-bold">Primary Mobile
                            Number*</label>
                        <input placeholder="" class="form-control" formControlName="mobileNumberPrimary" maxlength="10"
                            pattern="[0-9]*" inputmode="numeric">
                        <div *ngIf="registrationForm.get('mobileNumberPrimary')?.touched && registrationForm.get('mobileNumberPrimary')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            <label>{{ errorMessages.emptyPhoneNumberError }}</label>
                        </div>
                        <label for="Alternate Mobile Number" class="form-label font-weight-bold">Alternate Mobile
                            Number</label>
                        <input placeholder="" class="form-control" formControlName="mobileNumberAlternate"  maxlength="10">
                        <label for="Existing Ailment" class="form-label font-weight-bold">Existing Ailment</label>
                        <input placeholder="" class="form-control mb-3" formControlName="existingAilment">

                        
                        <label for="package" class="form-label font-weight-bold">Select Package*</label>
                        <select class="form-select mb-3" formControlName="package">
                            <option value="" selected disabled>Select Package</option>
                            <option *ngFor="let package of packages" [value]="package.id">
                                {{ package.packageName }}
                            </option>
                        </select>
                        <div *ngIf="registrationForm.get('package')?.touched && registrationForm.get('package')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            <label>{{ errorMessages.emptyPackageError }}</label>
                        </div>

                        <label for="baseLocation" class="form-label font-weight-bold">Base Location*</label>
                        <select class="form-select mb-3" formControlName="baseLocation"
                            (change)="selectOption($event, '')">
                            <option value="" selected disabled>Select Base Location</option>
                            <option *ngFor="let option of baseCenterMapping" [value]="option.city">
                                {{ option?.city }}
                            </option>
                        </select>
                        <div *ngIf="registrationForm.get('baseLocation')?.value === '' && registrationForm.get('centerLocation')?.value !== ''"
                            class="text-danger font-weight-bold">
                            {{ errorMessages.emptyBaseLocationError}}
                        </div>
                        <label for="centerLocation" class="form-label font-weight-bold">Choose Diagnostic Center
                            Location*</label>
                        <select class="form-select mb-3" formControlName="centerLocation">
                            <option value="" selected disabled>Locations in the Base Center</option>
                            <option *ngFor="let option of selectedBaseCenter?.centers" [value]="option">{{ option }}
                            </option>
                        </select>
                        <div *ngIf="registrationForm.get('centerLocation')?.value === '' && registrationForm.get('checkupDate')?.value !== ''"
                            class="text-danger font-weight-bold">
                            {{ errorMessages.emptyDiagnosticCenterError}}
                        </div>
                        <label for="consultationPreferenceTime" class="form-label font-weight-bold">Preferred Time
                            Slot*</label>
                        <div class="mb-3 time-selection" style="display: flex;">
                            <input type="date" class="form-control date-input" style="margin-right: 1rem;"
                                formControlName="checkupDate" [attr.min]="minDate">
                            <div class="d-flex align-items-center gap-2">
                                <div class="flex-grow-1">
                                    <timepicker formControlName="checkupTime" [meridians]="meridians"
                                        [showSpinners]="true" [showSeconds]="false" [hourStep]="1" [minuteStep]="15"
                                        [readonlyInput]="false"></timepicker>
                                </div>
                            </div>
                        </div>
                        
                        <div style="display: flex; justify-content: space-around;" class="mt-2">
                            <button class="btn btn-primary common" (click)="validate()">Register</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #exampleModalCenter>
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{ headerMessage }}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        {{ bodyMessage }}
    </div>
</ng-template> -->

<app-header></app-header>
<div class="container mt-5">
    <div class="row justify-content-center">
        <div class="col-md-6">
            <div class="card mb-3">
                <div class="card-header font-weight-bold common">
                    Your Primary Details
                </div>
                <div class="card-body">
                    <form [formGroup]="registrationForm">
                        <!-- Email -->
                        <label for="email" class="form-label font-weight-bold">Email Id*</label>
                        <input class="form-control" formControlName="email" readonly>

                        <!-- Name -->
                        <label for="name" class="form-label font-weight-bold mt-3">Name*</label>
                        <input class="form-control" formControlName="name">
                        <div *ngIf="registrationForm.get('name')?.touched && registrationForm.get('name')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            {{ errorMessages.emptyNameError }}
                        </div>

                        <!-- Age -->
                        <label for="age" class="form-label font-weight-bold mt-3">Age*</label>
                        <input class="form-control" formControlName="age" type="number">
                        <div *ngIf="registrationForm.get('age')?.touched && registrationForm.get('age')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            {{ errorMessages.emptyAgeError }}
                        </div>

                        <!-- Gender -->
                        <label for="gender" class="form-label font-weight-bold mt-3">Gender*</label>
                        <select class="form-select" formControlName="gender">
                            <option value="" selected disabled>Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Others">Others</option>
                        </select>
                        <div *ngIf="registrationForm.get('gender')?.touched && registrationForm.get('gender')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            {{ errorMessages.emptyGenderError }}
                        </div>

                        <!-- Primary Mobile Number -->
                        <label for="mobileNumberPrimary" class="form-label font-weight-bold mt-3">Primary Mobile Number*</label>
                        <input class="form-control" formControlName="mobileNumberPrimary" maxlength="10" pattern="[0-9]*">
                        <div *ngIf="registrationForm.get('mobileNumberPrimary')?.touched && registrationForm.get('mobileNumberPrimary')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            {{ errorMessages.emptyPhoneNumberError }}
                        </div>

                        <!-- Alternate Mobile Number -->
                        <!-- <label for="mobileNumberAlternate" class="form-label font-weight-bold mt-3">Alternate Mobile Number</label>
                        <input class="form-control" formControlName="mobileNumberAlternate" maxlength="10"> -->

                        <!-- Existing Ailment -->
                        <label for="existingAilment" class="form-label font-weight-bold mt-3">Existing Ailment</label>
                        <input class="form-control" formControlName="existingAilment">

                        <!-- Package -->
                        <label for="package" class="form-label font-weight-bold mt-3">Select Package*</label>
                        <select class="form-select" formControlName="package">
                            <option value="" selected disabled>Select Package</option>
                            <option *ngFor="let package of packages" [value]="package.id">{{ package.packageName }}</option>
                        </select>
                        <div *ngIf="registrationForm.get('package')?.touched && registrationForm.get('package')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            {{ errorMessages.emptyPackageError }}
                        </div>

                        <!-- Base Location -->
                        <label for="baseLocation" class="form-label font-weight-bold mt-3">Base Location*</label>
                        <select class="form-select" formControlName="baseLocation" (change)="selectOption($event, '')">
                            <option value="" selected disabled>Select Base Location</option>
                            <option *ngFor="let option of baseCenterMapping" [value]="option.city">{{ option.city }}</option>
                        </select>
                        <div *ngIf="registrationForm.get('baseLocation')?.touched && registrationForm.get('baseLocation')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            {{ errorMessages.emptyBaseLocationError }}
                        </div>

                        <!-- Diagnostic Center Location -->
                        <label for="centerLocation" class="form-label font-weight-bold mt-3">Choose Diagnostic Center Location*</label>
                        <select class="form-select" formControlName="centerLocation">
                            <option value="" selected disabled>Locations in the Base Center</option>
                            <option *ngFor="let option of selectedBaseCenter?.centers" [value]="option">{{ option }}</option>
                        </select>
                        <div *ngIf="registrationForm.get('centerLocation')?.touched && registrationForm.get('centerLocation')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            {{ errorMessages.emptyDiagnosticCenterError }}
                        </div>

                        <!-- Preferred Time Slot -->
                        <label for="consultationPreferenceTime" class="form-label font-weight-bold mt-3">Preferred Time Slot*</label>
                        <div class="mb-3 time-selection">
                            <input type="date" class="form-control date-input" formControlName="checkupDate" [attr.min]="minDate">
                            <timepicker class="" formControlName="checkupTime" [meridians]="meridians" [showSpinners]="true" [showSeconds]="false" [hourStep]="1" [minuteStep]="15"></timepicker>
                        </div>
                        <div *ngIf="registrationForm.get('checkupDate')?.touched && registrationForm.get('checkupDate')?.hasError('required')"
                            class="text-danger font-weight-bold mt-2">
                            {{ errorMessages.emptyTimeSlotError }}
                        </div>

                        <!-- Register Button -->
                        <div class="d-flex justify-content-center mt-4">
                            <button class="btn btn-primary common" (click)="validate()">Register</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #exampleModalCenter>
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{ headerMessage }}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        {{ bodyMessage }}
    </div>
</ng-template>